import { convertCompanyStatus } from "@/frontend/shared/lib/convertCompanyStatus/convertCompanyStatus";
import { TFormDataState, TParamsFilterData } from "../model/types/types";
import { type TSortables, type TSortDirection } from "../model/types/types";

export function parseFilterParams(base: TFormDataState, searchParams: URLSearchParams): TParamsFilterData {
  const filterData: TParamsFilterData = {
    formTags: {
      ...base?.formTags,
      tags: searchParams.get("clearTags") ? [] : base?.formTags?.tags || [],
      location: searchParams.get("regions")?.split(",") || []
    },
    aiPitchDescription: searchParams.get("prompt") || searchParams.get("name") || "",
    funding: {
      min: searchParams.get("fundingMin") || "",
      max: searchParams.get("fundingMax") || ""
    },
    foundingYear: {
      min: searchParams.get("foundingYearMin") || "",
      max: searchParams.get("foundingYearMax") || ""
    },
    lastFundingDateFrames: searchParams.get("lastFundingDateFrames")?.split(",") || [],
    financialStageFilters: {
      "Pre-Seed": false,
      Seed: false,
      "Series A": false,
      "Series B": false,
      "Series C": false,
      "Series D": false,
      "Series E+": false,
      Private: false,
      Undetermined: false,
      "IPO/Public Market": false,
      "Merge/Private Acquisition": false,
      "Out of Business": false,
      Grant: false,
      "Debt Financing": false
    }
  };

  const stages = searchParams.get("financialStages")?.split(",") || [];
  stages.forEach((stage) => {
    filterData.financialStageFilters[convertCompanyStatus(stage)] = true;
  });

  return filterData;
}

export function parseSortByParams(searchParams: URLSearchParams): TSortables {
  const VALID_VALUES = ["name", "financialStage", "totalFunding", "foundingYear"];
  const param = searchParams.get("sortBy");
  if (!param) {
    return null;
  }

  if (VALID_VALUES.includes(param)) {
    return param as TSortables;
  }

  return null;
}

export function parseSortOrderParams(searchParams: URLSearchParams): TSortDirection {
  const VALID_VALUES = ["asc", "desc"];
  const param = searchParams.get("sortOrder");
  if (!param) {
    return null;
  }

  if (VALID_VALUES.includes(param)) {
    return param as TSortDirection;
  }

  return null;
}
